<template>
  <div>
    <input type="file" id="avatar-upload" />
    <button @click="upda">上传</button>
    <!-- <el-upload
      class="upload-demo"
      ref="upload"
      action="https://jsonplaceholder.typicode.com/posts/"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :file-list="fileList"
      :multiple="true"
      :auto-upload="false"
      :limit="5"
    >
      <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
      <el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
      <div slot="tip" class="el-upload__tip">一次最多只能上传5个文件</div>
    </el-upload> -->
  </div>
</template>
<script>
import AV from "leancloud-storage";
import NJQuestion from "../../model/question";
import NGGrade from "../../model/grade";
import NGQuestionType from "../../model/questionType";
import Grade from '../../model/grade';

export default {
  data() {
    return {
      fileList: [],
      questionData: [],
      tigan: [],
      xuanxiang: [],
      answerSelection: [],
      questionTypesAV: [],
      grade: [],
      cgrade:''
    };
  },
  mounted() {
    let that = this;
    new AV.Query(NGQuestionType).ascending('templateType').find().then(questionTypes => {
      console.log(questionTypes);
      that.questionTypesAV = questionTypes;
    });
    new AV.Query(NGGrade).ascending('series').find().then(grades => {
      console.log(grades);
      that.grade = grades;
    });
  },
  methods: {
    upda() {
      const avatarUpload = document.getElementById("avatar-upload");
      if (avatarUpload.files.length) {
        const localFile = avatarUpload.files[0];
        const file = new AV.File(localFile, localFile);
        file.save().then(data => {
          console.log(data.attributes.name.name)
          this.uptimu(data.attributes.name.name,data.attributes.url)          
        });
      }
    },
    //上传up
    async uptimu(name,url){
      await this.getGrade(name)
      AV.Cloud.run("textRact", { url: url }).then(res => {
        console.log(res);
        this.Question(res);
      });
    },
    //获取年级
    async getGrade(name){
      if(name.search("三上")!= -1){
        new AV.Query(NGGrade).equalTo('number','1').first().then(grade=>{
          this.cgrade = grade
        })
      }else if(name.search("三下")!= -1){
        new AV.Query(NGGrade).equalTo('number','2').first().then(grade=>{
          this.cgrade = grade
        })
      }else if(name.search("四上")!= -1){
        new AV.Query(NGGrade).equalTo('number','3').first().then(grade=>{
          this.cgrade = grade
        })
      }else if(name.search("四下")!= -1){
        new AV.Query(NGGrade).equalTo('number','4').first().then(grade=>{
          this.cgrade = grade
        })
      }else if(name.search("五上")!= -1){
        new AV.Query(NGGrade).equalTo('number','5').first().then(grade=>{
          this.cgrade = grade
        })
      }else if(name.search("五下")!= -1){
        new AV.Query(NGGrade).equalTo('number','6').first().then(grade=>{
          this.cgrade = grade
        })
      }else if(name.search("六上")!= -1){
        new AV.Query(NGGrade).equalTo('number','7').first().then(grade=>{
          this.cgrade = grade
        })
      }else if(name.search("六下")!= -1){
        new AV.Query(NGGrade).equalTo('number','8').first().then(grade=>{
          this.cgrade = grade
        })
      }else if(name.search("七上")!= -1){
        new AV.Query(NGGrade).equalTo('number','9').first().then(grade=>{
          this.cgrade = grade
        })
      }else if(name.search("七下")!= -1){
        new AV.Query(NGGrade).equalTo('number','10').first().then(grade=>{
          this.cgrade = grade
        })
      }else if(name.search("八上")!= -1){
        new AV.Query(NGGrade).equalTo('number','11').first().then(grade=>{
          this.cgrade = grade
        })
      }else if(name.search("八下")!= -1){
        new AV.Query(NGGrade).equalTo('number','12').first().then(grade=>{
          this.cgrade = grade
        })
      }else if(name.search("九上")!= -1){
        new AV.Query(NGGrade).equalTo('number','13').first().then(grade=>{
          this.cgrade = grade
        })
      }else if(name.search("九下")!= -1){
        new AV.Query(NGGrade).equalTo('number','14').first().then(grade=>{
          this.cgrade = grade
        })
      }else{
        console.log('文件名有误')
        return
      }  
    },
    submitUpload() {
      console.log(this.$refs.upload.uploadFiles);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    Question(text) {
      this.choiceQuestion(text);
      this.choiceQuestion1(text);
      this.choiceQuestion2(text);
      this.choiceQuestion3(text);
      this.choiceQuestion4(text);
      this.choiceQuestion5(text);
      this.choiceQuestion6(text);
      this.choiceQuestion7(text);
      this.choiceQuestion8(text);
    },
    //听句子，选同义句
    choiceQuestion(textContent) {
      let that = this;
      var reg1 = /听句子，选同义句(.*?)听问句，选答句/;
      var reg2 = /[^【]*】/g; //获取题目与答案
      var reg3 = /(?<=([0-9][0-9]\.)|([0-9]\.)).*(?=A\.)/; //获取题干
      // var rega = /A\.(.*?)(\?)|A\.(.*?)(\.)/; //获取选项
      // var regb = /B\.(.*?)(\?)|B\.(.*?)(\.)/; //获取选项
      // var regc = /C\.(.*?)(\?)|C\.(.*?)(\.)/; //获取选项
      var reg4 = /(?<=答案：).*(?=标签：)/; //获取答案
      var reg5 = /标签：(.*?)】/
      var reg6 = /(?<=[A-Z]\.)(.*?)*/;//获取不带选项的具体答案
      var arr = textContent.match(reg1);
      console.log(arr);
      arr = arr[0].match(reg2);
      console.log(arr);
      for (let i = 0; i < arr.length; i++) {
        let questionData = [];
        let xuanxiang = [];
        let answerSelection = [];
        let tigan1 = [];
        let tigan = arr[i].split("设问：");
        tigan = tigan[0].split("题干：");
        console.log(tigan[1]);
        tigan1 = [
          {
            sn: 1,
            intro: tigan[1],
            image: "",
            voice: ""
          }
        ];
        let xx = arr[i].split("设问：");
        xx = xx[1].split("答案：");
        let tagN = xx[1].match(reg5);
        tagN=tagN[1].split(',')
        xx = xx[0].split("选项");
        for (let j = 1; j < xx.length; j++) {
          let xxl = xx[j].match(reg6)
          let xuan = {
            sn: j,
            intro: xxl[0],
            image: "",
            voice: ""
          };
          xuanxiang.push(xuan);
        }
        console.log(xuanxiang);
        let DaAn = arr[i].match(reg4);
        console.log(DaAn[0]);
        let daan = "";
        if (DaAn[0] == "A ") {
          daan = [xuanxiang[0]];
        } else if (DaAn[0] == "B ") {
          daan = [xuanxiang[1]];
        } else if (DaAn[0] == "C ") {
          daan = [xuanxiang[2]];
        } else if (DaAn[0] == "D ") {
          daan = [xuanxiang[3]];
        } else if (DaAn[0] == "E ") {
          daan = [xuanxiang[4]];
        } else if (DaAn[0] == "F ") {
          daan = [xuanxiang[5]];
        } else if (DaAn[0] == "G ") {
          daan = [xuanxiang[6]];
        }
        answerSelection.push(daan);
        questionData.push(tigan1);
        questionData.push(xuanxiang);
        let tags=[]
        for(let t=0;t<tagN.length;t++){
          tags.push(that.grade[tagN[t]])
        }
        const todo = new NJQuestion();

        todo.questionData=questionData;
        todo.answerSelection=answerSelection;
        todo.license='wxc534f9ed8a9993da';
        todo.tags=tags;
        todo.answerType=0;
        todo.grade = that.cgrade;
        todo.questionType=that.questionTypesAV[0];
        todo
          .save()
          .then(res => {
            console.log(res);
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    //听问句，选答句
    choiceQuestion1(textContent) {
      let that = this;
      var reg1 = /听问句，选答句(.*?)根据所听对话内容及问题，选答句/;
      var reg2 = /[^【]*】/g; //获取题目与答案
      var reg3 = /(?<=([0-9][0-9]\.)|([0-9]\.)).*(?=A\.)/; //获取题干
      // var rega = /A\.(.*?)(\?)|A\.(.*?)(\.)/; //获取选项
      // var regb = /B\.(.*?)(\?)|B\.(.*?)(\.)/; //获取选项
      // var regc = /C\.(.*?)(\?)|C\.(.*?)(\.)/; //获取选项
      var reg4 = /(?<=答案：).*(?=标签：)/; //获取答案
      var reg5 = /标签：(.*?)】/
      var reg6 = /(?<=[A-Z]\.)(.*?)*/;//获取不带选项的具体答案
      var arr = textContent.match(reg1);
      console.log(arr);
      arr = arr[0].match(reg2);
      console.log(arr);
      for (let i = 0; i < arr.length; i++) {
        let questionData = [];
        let xuanxiang = [];
        let answerSelection = [];
        let tigan1 = [];
        
        let tigan = arr[i].split("设问：");
        tigan = tigan[0].split("题干：");
        console.log(tigan[1]);
        tigan1 = [
          {
            sn: 1,
            intro: tigan[1],
            image: "",
            voice: ""
          }
        ];
        let xx = arr[i].split("设问：");
        xx = xx[1].split("答案：");
        let tagN = xx[1].match(reg5);
        tagN=tagN[1].split(',')
        xx = xx[0].split("选项");
        
        for (let j = 1; j < xx.length; j++) {
          let xxl = xx[j].match(reg6)
          let xuan = {
            sn: j,
            intro: xxl[0],
            image: "",
            voice: ""
          };
          xuanxiang.push(xuan);
        }
        console.log(xuanxiang);
        let DaAn = arr[i].match(reg4);
        console.log(DaAn[0]);
        let daan = "";
        if (DaAn[0] == "A ") {
          daan = [xuanxiang[0]];
        } else if (DaAn[0] == "B ") {
          daan = [xuanxiang[1]];
        } else if (DaAn[0] == "C ") {
          daan = [xuanxiang[2]];
        } else if (DaAn[0] == "D ") {
          daan = [xuanxiang[3]];
        } else if (DaAn[0] == "E ") {
          daan = [xuanxiang[4]];
        } else if (DaAn[0] == "F ") {
          daan = [xuanxiang[5]];
        } else if (DaAn[0] == "G ") {
          daan = [xuanxiang[6]];
        }
        answerSelection.push(daan);
        questionData.push(tigan1);
        questionData.push(xuanxiang);
        let tags=[]
        for(let t=0;t<tagN.length;t++){
          tags.push(that.grade[tagN[t]])
        }
        const todo = new NJQuestion();

        todo.questionData=questionData;
        todo.answerSelection=answerSelection;
        todo.license='wxc534f9ed8a9993da';
        todo.tags=tags;
        todo.grade = that.cgrade;
        todo.answerType=0;
        todo.questionType=that.questionTypesAV[0];
        todo
          .save()
          .then(res => {
            console.log(res);
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    //根据所听对话内容及问题，选答句
    choiceQuestion2(textContent) {
      let that = this;
      var reg1 = /根据所听对话内容及问题，选答句(.*?)听句子，选同义句。/;
      var reg2 = /[^【]*】/g; //获取题目与答案
      // var reg3 = /(?<=([0-9][0-9]\.)|([0-9]\.)).*(?=A\.)/; //获取题干
      // var rega = /A\.(.*?)(\?)|A\.(.*?)(\.)/; //获取选项
      // var regb = /B\.(.*?)(\?)|B\.(.*?)(\.)/; //获取选项
      // var regc = /C\.(.*?)(\?)|C\.(.*?)(\.)/; //获取选项
      var reg4 = /(?<=答案：).*(?=标签：)/; //获取答案
      var reg5 = /标签：(.*?)】/
      var reg6 = /(?<=[A-Z]\.)(.*?)*/;//获取不带选项的具体答案
      var arr = textContent.match(reg1);
      console.log(arr);
      arr = arr[0].match(reg2);
      console.log(arr);
      for (let i = 0; i < arr.length; i++) {
        let questionData = [];
        let xuanxiang = [];
        let answerSelection = [];
        let tigan1 = [];
        let tigan = arr[i].split("设问：");
        tigan = tigan[0].split("题干：");
        tigan = tigan[1].split("对话");
        for (let k = 1; k < tigan.length; k++) {
          let dui = {
            sn: k,
            intro: tigan[k],
            image: "",
            voice: ""
          };
          tigan1.push(dui);
        }
        let xx = arr[i].split("设问：");
        xx = xx[1].split("答案：");
        let tagN = xx[1].match(reg5);
        tagN=tagN[1].split(',')
        xx = xx[0].split("选项");
        for (let j = 1; j < xx.length; j++) {
          let xxl = xx[j].match(reg6)
          let xuan = {
            sn: j,
            intro: xxl[0],
            image: "",
            voice: ""
          };
          xuanxiang.push(xuan);
        }
        console.log(xuanxiang);
        let DaAn = arr[i].match(reg4);
        console.log(DaAn[0]);
        let daan = "";
        if (DaAn[0] == "A ") {
          daan = [xuanxiang[0]];
        } else if (DaAn[0] == "B ") {
          daan = [xuanxiang[1]];
        } else if (DaAn[0] == "C ") {
          daan = [xuanxiang[2]];
        } else if (DaAn[0] == "D ") {
          daan = [xuanxiang[3]];
        } else if (DaAn[0] == "E ") {
          daan = [xuanxiang[4]];
        } else if (DaAn[0] == "F ") {
          daan = [xuanxiang[5]];
        } else if (DaAn[0] == "G ") {
          daan = [xuanxiang[6]];
        }
        answerSelection.push(daan);
        questionData.push(tigan1);
        questionData.push(xuanxiang);
        let tags=[]
        for(let t=0;t<tagN.length;t++){
          tags.push(that.grade[tagN[t]])
        }
        const todo = new NJQuestion();

        todo.questionData=questionData;
        todo.answerSelection=answerSelection;
        todo.license='wxc534f9ed8a9993da';
        todo.tags=tags;
        todo.grade = that.cgrade;
        todo.answerType=0;
        todo.questionType=that.questionTypesAV[0];
        todo
          .save()
          .then(res => {
            console.log(res);
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    //二、听问句，选答句
    choiceQuestion4(textContent) {
      let that = this;
      var reg = /听力选听力(.*?)跟读/;
      var reg1 = /听问句，选答句(.*?)根据所听对话内容及问题，选答句/;
      var reg2 = /[^【]*】/g; //获取题目与答案
      var reg3 = /(?<=([0-9][0-9]\.)|([0-9]\.)).*(?=A\.)/; //获取题干
      // var rega = /A\.(.*?)(\?)|A\.(.*?)(\.)/; //获取选项
      // var regb = /B\.(.*?)(\?)|B\.(.*?)(\.)/; //获取选项
      // var regc = /C\.(.*?)(\?)|C\.(.*?)(\.)/; //获取选项
      var reg4 = /(?<=答案：).*(?=标签：)/; //获取答案
      var reg5 = /标签：(.*?)】/ //获取标签
      var reg6 = /(?<=[A-Z]\.)(.*?)*/;//获取不带选项的具体答案
      var arr = textContent.match(reg);
      arr = arr[0].match(reg1)
      console.log(arr);
      arr = arr[0].match(reg2);
      console.log(arr);
      for (let i = 0; i < arr.length; i++) {
        let questionData = [];
        let xuanxiang = [];
        let answerSelection = [];
        let tigan1 = [];

        let tigan = arr[i].split("设问：");
        tigan = tigan[0].split("题干：");
        console.log(tigan[1]);
        tigan1 = [
          {
            sn: 1,
            intro: tigan[1],
            image: "",
            voice: ""
          }
        ];
        let xx = arr[i].split("设问：");
        xx = xx[1].split("答案：");
        let tagN = xx[1].match(reg5);
        tagN=tagN[1].split(',')
        xx = xx[0].split("选项");
        for (let j = 1; j < xx.length; j++) {
          let xxl = xx[j].match(reg6)
          let xuan = {
            sn: j,
            intro: xxl[0],
            image: "",
            voice: ""
          };
          xuanxiang.push(xuan);
        }
        console.log(xuanxiang);
        let DaAn = arr[i].match(reg4);
        console.log(DaAn[0]);
        let daan = "";
        if (DaAn[0] == "A ") {
          daan = [xuanxiang[0]];
        } else if (DaAn[0] == "B ") {
          daan = [xuanxiang[1]];
        } else if (DaAn[0] == "C ") {
          daan = [xuanxiang[2]];
        } else if (DaAn[0] == "D ") {
          daan = [xuanxiang[3]];
        } else if (DaAn[0] == "E ") {
          daan = [xuanxiang[4]];
        } else if (DaAn[0] == "F ") {
          daan = [xuanxiang[5]];
        } else if (DaAn[0] == "G ") {
          daan = [xuanxiang[6]];
        }
        answerSelection.push(daan);
        questionData.push(tigan1);
        questionData.push(xuanxiang);
        let tags=[]
        for(let t=0;t<tagN.length;t++){
          tags.push(that.grade[tagN[t]])
        }
        const todo = new NJQuestion();

        todo.questionData=questionData;
        todo.answerSelection=answerSelection;
        todo.license='wxc534f9ed8a9993da';
        todo.tags=tags;
        todo.grade = that.cgrade;
        todo.answerType=0;
        todo.questionType=that.questionTypesAV[0];
        todo
          .save()
          .then(res => {
            console.log(res);
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    //二、听句子，选同义句
    choiceQuestion3(textContent) {
      let that = this;
      var reg = /听力选听力(.*?)跟读/;
      var reg1 = /听句子，选同义句(.*?)听问句，选答句/;
      var reg2 = /[^【]*】/g; //获取题目与答案
      var reg3 = /(?<=([0-9][0-9]\.)|([0-9]\.)).*(?=A\.)/; //获取题干
      // var rega = /A\.(.*?)(\?)|A\.(.*?)(\.)/; //获取选项
      // var regb = /B\.(.*?)(\?)|B\.(.*?)(\.)/; //获取选项
      // var regc = /C\.(.*?)(\?)|C\.(.*?)(\.)/; //获取选项
      var reg4 = /(?<=答案：).*(?=标签：)/; //获取答案
      var reg5 = /标签：(.*?)】/ //获取标签
      var reg6 = /(?<=[A-Z]\.)(.*?)*/;//获取不带选项的具体答案
      var arr = textContent.match(reg);
      arr = arr[0].match(reg1)
      console.log(arr);
      arr = arr[0].match(reg2);
      console.log(arr);
      for (let i = 0; i < arr.length; i++) {
        let questionData = [];
        let xuanxiang = [];
        let answerSelection = [];
        let tigan1 = [];

        let tigan = arr[i].split("设问：");
        tigan = tigan[0].split("题干：");
        console.log(tigan[1]);
        tigan1 = [
          {
            sn: 1,
            intro: tigan[1],
            image: "",
            voice: ""
          }
        ];
        let xx = arr[i].split("设问：");
        xx = xx[1].split("答案：");
        let tagN = xx[1].match(reg5);
        tagN=tagN[1].split(',')
        xx = xx[0].split("选项");
        for (let j = 1; j < xx.length; j++) {
          let xxl = xx[j].match(reg6)
          let xuan = {
            sn: j,
            intro: xxl[0],
            image: "",
            voice: ""
          };
          xuanxiang.push(xuan);
        }
        console.log(xuanxiang);
        let DaAn = arr[i].match(reg4);
        console.log(DaAn[0]);
        let daan = "";
        if (DaAn[0] == "A ") {
          daan = [xuanxiang[0]];
        } else if (DaAn[0] == "B ") {
          daan = [xuanxiang[1]];
        } else if (DaAn[0] == "C ") {
          daan = [xuanxiang[2]];
        } else if (DaAn[0] == "D ") {
          daan = [xuanxiang[3]];
        } else if (DaAn[0] == "E ") {
          daan = [xuanxiang[4]];
        } else if (DaAn[0] == "F ") {
          daan = [xuanxiang[5]];
        } else if (DaAn[0] == "G ") {
          daan = [xuanxiang[6]];
        }
        answerSelection.push(daan);
        questionData.push(tigan1);
        questionData.push(xuanxiang);
        let tags=[]
        for(let t=0;t<tagN.length;t++){
          tags.push(that.grade[tagN[t]])
        }
        const todo = new NJQuestion();

        todo.questionData=questionData;
        todo.answerSelection=answerSelection;
        todo.license='wxc534f9ed8a9993da';
        todo.tags=tags;
        todo.grade = that.cgrade;
        todo.answerType=0;
        todo.questionType=that.questionTypesAV[0];
        todo
          .save()
          .then(res => {
            console.log(res);
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    //二、根据所听对话内容及问题，选答句
    choiceQuestion5(textContent) {
     let that = this;
      var reg = /听力选听力(.*?)跟读/;
      var reg1 = /根据所听对话内容及问题，选答句(.*?)*/;
      var reg2 = /[^【]*】/g; //获取题目与答案
      var reg3 = /(?<=([0-9][0-9]\.)|([0-9]\.)).*(?=A\.)/; //获取题干
      // var rega = /A\.(.*?)(\?)|A\.(.*?)(\.)/; //获取选项
      // var regb = /B\.(.*?)(\?)|B\.(.*?)(\.)/; //获取选项
      // var regc = /C\.(.*?)(\?)|C\.(.*?)(\.)/; //获取选项
      var reg4 = /(?<=答案：).*(?=标签：)/; //获取答案
      var reg5 = /标签：(.*?)】/ //获取标签
      var reg6 = /(?<=[A-Z]\.)(.*?)*/;//获取不带选项的具体答案
      var arr = textContent.match(reg);
      arr = arr[0].match(reg1)
      console.log(arr);
      arr = arr[0].match(reg2);
      console.log(arr);
      for (let i = 0; i < arr.length; i++) {
        let questionData = [];
        let xuanxiang = [];
        let answerSelection = [];
        let tigan1 = [];
        let tigan = arr[i].split("设问：");
        tigan = tigan[0].split("题干：");
        tigan = tigan[1].split("对话");
        for (let k = 1; k < tigan.length; k++) {
          let dui = {
            sn: k,
            intro: tigan[k],
            image: "",
            voice: ""
          };
          tigan1.push(dui);
        }
        let xx = arr[i].split("设问：");
        xx = xx[1].split("答案：");
        let tagN = xx[1].match(reg5);
        tagN=tagN[1].split(',')
        xx = xx[0].split("选项");
        for (let j = 1; j < xx.length; j++) {
          let xxl = xx[j].match(reg6)
          let xuan = {
            sn: j,
            intro: xxl[0],
            image: "",
            voice: ""
          };
          xuanxiang.push(xuan);
        }
        console.log(xuanxiang);
        let DaAn = arr[i].match(reg4);
        console.log(DaAn[0]);
        let daan = "";
        if (DaAn[0] == "A ") {
          daan = [xuanxiang[0]];
        } else if (DaAn[0] == "B ") {
          daan = [xuanxiang[1]];
        } else if (DaAn[0] == "C ") {
          daan = [xuanxiang[2]];
        } else if (DaAn[0] == "D ") {
          daan = [xuanxiang[3]];
        } else if (DaAn[0] == "E ") {
          daan = [xuanxiang[4]];
        } else if (DaAn[0] == "F ") {
          daan = [xuanxiang[5]];
        } else if (DaAn[0] == "G ") {
          daan = [xuanxiang[6]];
        }
        answerSelection.push(daan);
        questionData.push(tigan1);
        questionData.push(xuanxiang);
        let tags=[]
        for(let t=0;t<tagN.length;t++){
          tags.push(that.grade[tagN[t]])
        }
        const todo = new NJQuestion();

        todo.questionData=questionData;
        todo.answerSelection=answerSelection;
        todo.license='wxc534f9ed8a9993da';
        todo.tags=tags;
        todo.grade = that.cgrade;
        todo.answerType=0;
        todo.questionType=that.questionTypesAV[0];
        todo
          .save()
          .then(res => {
            console.log(res);
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    //跟读
    choiceQuestion6(textContent) {
      let that = this;
      var reg1 = /跟读(.*?)复述/;
      var reg2 = /[^【]*】/g; //获取题目与答案
      // var reg3 = /(?<=([0-9][0-9]\.)|([0-9]\.)).*(?=A\.)/; //获取题干
      // var rega = /A\.(.*?)(\?)|A\.(.*?)(\.)/; //获取选项
      // var regb = /B\.(.*?)(\?)|B\.(.*?)(\.)/; //获取选项
      // var regc = /C\.(.*?)(\?)|C\.(.*?)(\.)/; //获取选项
      var reg4 = /(?<=[0-90]\.)(.*?)(?=标签)/; //获取答案
      var reg5 = /标签：(.*?)】/ //获取标签
      var arr = textContent.match(reg1);
      console.log(arr);
      arr = arr[0].match(reg2);
      for (let i=0; i < arr.length; i++) {
        let questionData = [];
        let xuanxiang = [];
        let answerSelection = [];
        let daan={}
        let tigan1 = [];
        let ti = arr[i].match(reg4);
        let tagN = arr[1].match(reg5);
        tagN=tagN[1].split(',')
        ti = ti[0].split("——");
        if(ti.length>1){
          for(let j=1;j<ti.length;j++){
            let tl = {
              sn: j,
              intro: ti[j],
              image: "",
              voice: ""
            }
            tigan1.push(tl)
          }
        }else{
          tigan1 = [
            {
              sn: 1,
              intro: ti[0],
              image: "",
              voice: ""
            }
          ];
        }
        console.log(tigan1)
        answerSelection.push(daan);
        questionData.push(tigan1);
        questionData.push(xuanxiang);
        let tags=[]
        for(let t=0;t<tagN.length;t++){
          tags.push(that.grade[tagN[t]])
        }
        const todo = new NJQuestion();

        todo.questionData=questionData;
        todo.answerSelection=answerSelection;
        todo.license='wxc534f9ed8a9993da';
        todo.tags=tags;
        todo.grade = that.cgrade;
        todo.answerType=0;
        todo.questionType=that.questionTypesAV[0];
        todo
          .save()
          .then(res => {
            console.log(res);
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    //复述
    choiceQuestion7(textContent) {
      let that = this;
      var reg1 = /复述(.*?)情景问答/;
      var reg2 = /[^【]*】/g; //获取题目与答案
      // var reg3 = /(?<=([0-9][0-9]\.)|([0-9]\.)).*(?=A\.)/; //获取题干
      // var rega = /A\.(.*?)(\?)|A\.(.*?)(\.)/; //获取选项
      // var regb = /B\.(.*?)(\?)|B\.(.*?)(\.)/; //获取选项
      // var regc = /C\.(.*?)(\?)|C\.(.*?)(\.)/; //获取选项
      var reg4 = /(?<=[0-90]\.)(.*?)(?=标签)/; //获取答案
      var reg5 = /标签：(.*?)】/ //获取标签
      var arr = textContent.match(reg1);
      console.log(arr);
      arr = arr[0].match(reg2);
      for (let i=0; i < arr.length; i++) {
        let questionData = [];
        let xuanxiang = [];
        let answerSelection = [];
        let daan={}
        let tigan1 = [];
        let ti = arr[i].match(reg4);
        let tagN = arr[1].match(reg5);
        tagN=tagN[1].split(',')
        ti = ti[0].split("——");
        if(ti.length>1){
          for(let j=1;j<ti.length;j++){
            let tl = {
              sn: j,
              intro: ti[j],
              image: "",
              voice: ""
            }
            tigan1.push(tl)
          }
        }else{
          tigan1 = [
            {
              sn: 1,
              intro: ti[0],
              image: "",
              voice: ""
            }
          ];
        }
        console.log(tigan1)
        answerSelection.push(daan);
        questionData.push(tigan1);
        questionData.push(xuanxiang);
        let tags=[]
        for(let t=0;t<tagN.length;t++){
          tags.push(that.grade[tagN[t]])
        }
        const todo = new NJQuestion();

        todo.questionData=questionData;
        todo.answerSelection=answerSelection;
        todo.license='wxc534f9ed8a9993da';
        todo.tags=tags;
        todo.grade = that.cgrade;
        todo.answerType=0;
        todo.questionType=that.questionTypesAV[0];
        todo
          .save()
          .then(res => {
            console.log(res);
          })
          .catch(err => {
            console.log(err);
          });
      }
    },
    //根据所听对话内容及问题，选答句
    choiceQuestion8(textContent) {
      let that = this;
      var reg1 = /情景问答(.*?)*/;
      var reg2 = /[^【]*】/g; //获取题目与答案
      // var reg3 = /(?<=([0-9][0-9]\.)|([0-9]\.)).*(?=A\.)/; //获取题干
      // var rega = /A\.(.*?)(\?)|A\.(.*?)(\.)/; //获取选项
      // var regb = /B\.(.*?)(\?)|B\.(.*?)(\.)/; //获取选项
      // var regc = /C\.(.*?)(\?)|C\.(.*?)(\.)/; //获取选项
      var reg4 = /(?<=答案：).*(?=标签：)/; //获取答案
      var reg5 = /标签：(.*?)】/ //获取标签
      var arr = textContent.match(reg1);
      console.log(arr);
      arr = arr[0].match(reg2);
      console.log(arr);
      for (let i = 0; i < arr.length; i++) {
        let questionData = [];
        let xuanxiang = [];
        let answerSelection = [];
        let tigan1 = [];
        let daan={};
        let dh = arr[1].split("对话");
        let tagN = arr[1].match(reg5);
        tagN=tagN[1].split(',')
        let tig = dh[0].split("题干：")
        let tigan = {
              sn: 1,
              intro: tig[1],
              image: "",
              voice: ""
            }
        tigan1.push(tigan);
        for (let k = 1; k < dh.length; k++) {
          let dui = {
            sn: k+1,
            intro: dh[k],
            image: "",
            voice: ""
          };
          tigan1.push(dui);
        }
        answerSelection.push(daan);
        questionData.push(tigan1);
        questionData.push(xuanxiang);
        let tags=[]
        for(let t=0;t<tagN.length;t++){
          tags.push(that.grade[tagN[t]])
        }
        const todo = new NJQuestion();

        todo.questionData=questionData;
        todo.answerSelection=answerSelection;
        todo.license='wxc534f9ed8a9993da';
        todo.tags=tags;
        todo.answerType=0;
        todo.grade = that.cgrade;
        todo.questionType=that.questionTypesAV[0];
        todo
          .save()
          .then(res => {
            console.log(res);
          })
          .catch(err => {
            console.log(err);
          });
      }
    }
    // choiceQuestion1(textContent){
    //   let that=this
    //   that.questionData=[]
    //   that.xuanxiang = []
    //   that.answerSelection=[]
    //   var reg1 = /听问句，选答句(.*?)根据所听对话内容及问题，选答句/
    //   var reg2 = /[^【]*】/g; //获取题目与答案
    //   var reg3 = /(?<=([0-9][0-9]\.)|([0-9]\.)).*(?=A\.)/; //获取题干
    //  var rega = /A\.(.*?)(\?)|A\.(.*?)(\.)/; //获取选项
    //   var regb = /B\.(.*?)(\?)|B\.(.*?)(\.)/; //获取选项
    //   var regc = /C\.(.*?)(\?)|C\.(.*?)(\.)/; //获取选项
    //   var reg4 = /(?<=答案：).*(?=标签：)/; //获取答案
    //   var arr = textContent.match(reg1);
    //   console.log(arr)
    //   arr = arr[0].match(reg2)
    //   console.log(arr)
    //   for(let i=0;i<arr.length;i++){
    //     let tigan = arr[i].match(reg3)
    //     console.log(tigan)
    //     let A = arr[i].match(rega)
    //     console.log(A[0])
    //     let B = arr[i].match(regb)
    //     console.log(B[0])
    //     let C = arr[i].match(regc)
    //     console.log(C[0])
    //     let DaAn = arr[i].match(reg4)
    //     console.log(DaAn[0])
    //     let tigan1 =[]
    //     for(let j=0;j<1;j++){
    //       tigan1.push(
    //         {
    //           "sn": j+1,
    //           "intro": tigan[j],
    //           "image": "",
    //           "voice": ""
    //         }
    //       )
    //       console.log(tigan1)
    //     }
    //     that.tigan.push(tigan1)
    //     console.log(that.tigan)
    //     let xuanA={
    //       "sn": 1,
    //       "intro": A[0],
    //       "image": "",
    //       "voice": ""
    //     }
    //     let xuanB={
    //       "sn": 2,
    //       "intro": B[0],
    //       "image": "",
    //       "voice": ""
    //     }
    //     let xuanC={
    //       "sn": 3,
    //       "intro": C[0],
    //       "image": "",
    //       "voice": ""
    //     }
    //     let daan=''
    //     if(DaAn[0] == 'A '){
    //       daan=[xuanA]

    //     }else if(DaAn[0] == 'B '){
    //       daan=[xuanB]

    //     }else if(DaAn[0] == 'C '){
    //       daan=[xuanC]

    //     }
    //     that.answerSelection.push(daan)

    //     let questionData1 = []
    //     that.xuanxiang=[xuanA,xuanB,xuanC]
    //     questionData1=[tigan1,that.xuanxiang]

    //     that.questionData.push(questionData1)
    //   }
    //   console.log(that.questionData)
    //   console.log(that.answerSelection)
    //   console.log(that.questionTypesAV)
    //   for(let k in that.questionData){
    //     const todo = new NJQuestion();
    //     todo.set('questionData',that.questionData[k])
    //     todo.set('answerSelection',that.answerSelection[k])
    //     todo.set('license','wxc534f9ed8a9993da')
    //     todo.set('grade',that.grade[33])
    //     todo.set('answerType',0)
    //     todo.set('questionType',that.questionTypesAV[0])
    //     todo.save().then( res=>{
    //       console.log(res)
    //     }).catch(err=>{
    //       console.log(err)
    //     })
    //   }
    // },
    // choiceQuestion2(textContent){
    //   let that=this
    //   that.questionData=[]
    //   that.xuanxiang = []
    //   that.answerSelection=[]
    //   var reg1 = /根据所听对话内容及问题，选答句(.*?)听句子，选同义句/
    //   var reg2 = /[^【]*】/g; //获取题目与答案
    //   var reg3 = /(?<=([0-9][0-9]\.)|([0-9]\.)).*(?=A\.)/; //获取题干
    //   var rega = /A\.(.*?)(\?)|A\.(.*?)(\.)/; //获取选项
    //   var regb = /B\.(.*?)(\?)|B\.(.*?)(\.)/; //获取选项
    //   var regc = /C\.(.*?)(\?)|C\.(.*?)(\.)/; //获取选项
    //   var reg4 = /(?<=答案：).*(?=标签：)/; //获取答案
    //   var arr = textContent.match(reg1);
    //   console.log(arr)
    //   arr = arr[0].match(reg2)
    //   console.log(arr)
    //   for(let i=0;i<arr.length;i++){
    //     let tigan = arr[i].match(reg3)
    //     console.log(tigan)
    //     let A = arr[i].match(rega)
    //     console.log(A[0])
    //     let B = arr[i].match(regb)
    //     console.log(B[0])
    //     let C = arr[i].match(regc)
    //     console.log(C[0])
    //     let DaAn = arr[i].match(reg4)
    //     console.log(DaAn[0])
    //     let tigan1 =[]
    //     for(let j=0;j<1;j++){
    //       tigan1.push(
    //         {
    //           "sn": j+1,
    //           "intro": tigan[j],
    //           "image": "",
    //           "voice": ""
    //         }
    //       )
    //       console.log(tigan1)
    //     }
    //     that.tigan.push(tigan1)
    //     console.log(that.tigan)
    //     let xuanA={
    //       "sn": 1,
    //       "intro": A[0],
    //       "image": "",
    //       "voice": ""
    //     }
    //     let xuanB={
    //       "sn": 2,
    //       "intro": B[0],
    //       "image": "",
    //       "voice": ""
    //     }
    //     let xuanC={
    //       "sn": 3,
    //       "intro": C[0],
    //       "image": "",
    //       "voice": ""
    //     }
    //     let daan=''
    //     if(DaAn[0] == 'A '){
    //       daan=[xuanA]

    //     }else if(DaAn[0] == 'B '){
    //       daan=[xuanB]

    //     }else if(DaAn[0] == 'C '){
    //       daan=[xuanC]

    //     }
    //     that.answerSelection.push(daan)

    //     let questionData1 = []
    //     that.xuanxiang=[xuanA,xuanB,xuanC]
    //     questionData1=[tigan1,that.xuanxiang]

    //     that.questionData.push(questionData1)
    //   }
    //   console.log(that.questionData)
    //   console.log(that.answerSelection)
    //   console.log(that.questionTypesAV)
    //   for(let k in that.questionData){
    //     const todo = new NJQuestion();
    //     todo.set('questionData',that.questionData[k])
    //     todo.set('answerSelection',that.answerSelection[k])
    //     todo.set('license','wxc534f9ed8a9993da')
    //     todo.set('grade',that.grade[33])
    //     todo.set('answerType',0)
    //     todo.set('questionType',that.questionTypesAV[0])
    //     todo.save().then( res=>{
    //       console.log(res)
    //     }).catch(err=>{
    //       console.log(err)
    //     })
    //   }
    // },
    // choiceQuestion3(textContent){
    //   let that=this
    //   that.questionData=[]
    //   that.xuanxiang = []
    //   that.answerSelection=[]
    //   var reg1 = /听句子，选同义句(.*?)听问句，选答句/
    //   var reg2 = /[^【]*】/g; //获取题目与答案
    //   var reg3 = /(?<=([0-9][0-9]\.)|([0-9]\.)).*(?=A\.)/; //获取题干
    //   var rega = /A\.(.*?)(\?)|A\.(.*?)(\.)/; //获取选项
    //   var regb = /B\.(.*?)(\?)|B\.(.*?)(\.)/; //获取选项
    //   var regc = /C\.(.*?)(\?)|C\.(.*?)(\.)/; //获取选项
    //   var reg4 = /(?<=答案：).*(?=标签：)/; //获取答案
    //   var arr = textContent.match(reg1);
    //   console.log(arr)
    //   arr = arr[0].match(reg2)
    //   console.log(arr)
    //   for(let i=0;i<arr.length;i++){
    //     let tigan = arr[i].match(reg3)
    //     console.log(tigan)
    //     let A = arr[i].match(rega)
    //     console.log(A[0])
    //     let B = arr[i].match(regb)
    //     console.log(B[0])
    //     let C = arr[i].match(regc)
    //     console.log(C[0])
    //     let DaAn = arr[i].match(reg4)
    //     console.log(DaAn[0])
    //     let tigan1 =[]
    //     for(let j=0;j<1;j++){
    //       tigan1.push(
    //         {
    //           "sn": j+1,
    //           "intro": tigan[j],
    //           "image": "",
    //           "voice": ""
    //         }
    //       )
    //       console.log(tigan1)
    //     }
    //     that.tigan.push(tigan1)
    //     console.log(that.tigan)
    //     let xuanA={
    //       "sn": 1,
    //       "intro": A[0],
    //       "image": "",
    //       "voice": ""
    //     }
    //     let xuanB={
    //       "sn": 2,
    //       "intro": B[0],
    //       "image": "",
    //       "voice": ""
    //     }
    //     let xuanC={
    //       "sn": 3,
    //       "intro": C[0],
    //       "image": "",
    //       "voice": ""
    //     }
    //     let daan=''
    //     if(DaAn[0] == 'A '){
    //       daan=[xuanA]

    //     }else if(DaAn[0] == 'B '){
    //       daan=[xuanB]

    //     }else if(DaAn[0] == 'C '){
    //       daan=[xuanC]

    //     }
    //     that.answerSelection.push(daan)

    //     let questionData1 = []
    //     that.xuanxiang=[xuanA,xuanB,xuanC]
    //     questionData1=[tigan1,that.xuanxiang]

    //     that.questionData.push(questionData1)
    //   }
    //   console.log(that.questionData)
    //   console.log(that.answerSelection)
    //   console.log(that.questionTypesAV)
    //   for(let k in that.questionData){
    //     const todo = new NJQuestion();
    //     todo.set('questionData',that.questionData[k])
    //     todo.set('answerSelection',that.answerSelection[k])
    //     todo.set('license','wxc534f9ed8a9993da')
    //     todo.set('grade',that.grade[33])
    //     todo.set('answerType',0)
    //     todo.set('questionType',that.questionTypesAV[0])
    //     todo.save().then( res=>{
    //       console.log(res)
    //     }).catch(err=>{
    //       console.log(err)
    //     })
    //   }
    // },
    // choiceQuestion4(textContent){
    //   let that=this
    //   that.questionData=[]
    //   that.xuanxiang = []
    //   that.answerSelection=[]
    //   var reg1 = /听问句，选答句(.*?)根据所听对话内容及问题，选听答句/
    //   var reg2 = /[^【]*】/g; //获取题目与答案
    //   var reg3 = /(?<=([0-9][0-9]\.)|([0-9]\.)).*(?=A\.)/; //获取题干
    //   var rega = /A\.(.*?)(\?)|A\.(.*?)(\.)/; //获取选项
    //   var regb = /B\.(.*?)(\?)|B\.(.*?)(\.)/; //获取选项
    //   var regc = /C\.(.*?)(\?)|C\.(.*?)(\.)/; //获取选项
    //   var reg4 = /(?<=答案：).*(?=标签：)/; //获取答案
    //   var arr = textContent.match(reg1);
    //   console.log(arr)
    //   arr = arr[0].match(reg2)
    //   console.log(arr)
    //   for(let i=0;i<arr.length;i++){
    //     let tigan = arr[i].match(reg3)
    //     console.log(tigan)
    //     let A = arr[i].match(rega)
    //     console.log(A[0])
    //     let B = arr[i].match(regb)
    //     console.log(B[0])
    //     let C = arr[i].match(regc)
    //     console.log(C[0])
    //     let DaAn = arr[i].match(reg4)
    //     console.log(DaAn[0])
    //     let tigan1 =[]
    //     for(let j=0;j<1;j++){
    //       tigan1.push(
    //         {
    //           "sn": j+1,
    //           "intro": tigan[j],
    //           "image": "",
    //           "voice": ""
    //         }
    //       )
    //       console.log(tigan1)
    //     }
    //     that.tigan.push(tigan1)
    //     console.log(that.tigan)
    //     let xuanA={
    //       "sn": 1,
    //       "intro": A[0],
    //       "image": "",
    //       "voice": ""
    //     }
    //     let xuanB={
    //       "sn": 2,
    //       "intro": B[0],
    //       "image": "",
    //       "voice": ""
    //     }
    //     let xuanC={
    //       "sn": 3,
    //       "intro": C[0],
    //       "image": "",
    //       "voice": ""
    //     }
    //     let daan=''
    //     if(DaAn[0] == 'A '){
    //       daan=[xuanA]

    //     }else if(DaAn[0] == 'B '){
    //       daan=[xuanB]

    //     }else if(DaAn[0] == 'C '){
    //       daan=[xuanC]

    //     }
    //     that.answerSelection.push(daan)

    //     let questionData1 = []
    //     that.xuanxiang=[xuanA,xuanB,xuanC]
    //     questionData1=[tigan1,that.xuanxiang]

    //     that.questionData.push(questionData1)
    //   }
    //   console.log(that.questionData)
    //   console.log(that.answerSelection)
    //   console.log(that.questionTypesAV)
    //   for(let k in that.questionData){
    //     const todo = new NJQuestion();
    //     todo.set('questionData',that.questionData[k])
    //     todo.set('answerSelection',that.answerSelection[k])
    //     todo.set('license','wxc534f9ed8a9993da')
    //     todo.set('grade',that.grade[33])
    //     todo.set('answerType',0)
    //     todo.set('questionType',that.questionTypesAV[0])
    //     todo.save().then( res=>{
    //       console.log(res)
    //     }).catch(err=>{
    //       console.log(err)
    //     })
    //   }
    // },
    // choiceQuestion5(textContent){
    //   let that=this
    //   that.questionData=[]
    //   that.xuanxiang = []
    //   that.answerSelection=[]
    //   var reg1 = /根据所听对话内容及问题，选听答句(.*?)跟读/
    //   var reg2 = /[^【]*】/g; //获取题目与答案
    //   var reg3 = /(?<=([0-9][0-9]\.)|([0-9]\.)).*(?=A\.)/; //获取题干
    //   var rega = /(?=A).*(?=B\.)/; //获取选项
    //   var regb = /(?=B).*(?=C\.)/; //获取选项
    //   var regc = /(?=C).*(?=\.)/; //获取选项
    //   var reg4 = /(?<=答案：).*(?=标签：)/; //获取答案
    //   var arr = textContent.match(reg1);
    //   console.log(arr)
    //   arr = arr[0].match(reg2)
    //   console.log(arr)
    //   for(let i=0;i<arr.length;i++){
    //     let tigan = arr[i].match(reg3)
    //     console.log(tigan)
    //     let A = arr[i].match(rega)
    //     console.log(A[0])
    //     let B = arr[i].match(regb)
    //     console.log(B[0])
    //     let C = arr[i].match(regc)
    //     console.log(C[0])
    //     let DaAn = arr[i].match(reg4)
    //     console.log(DaAn[0])
    //     let tigan1 =[]
    //     for(let j=0;j<1;j++){
    //       tigan1.push(
    //         {
    //           "sn": j+1,
    //           "intro": tigan[j],
    //           "image": "",
    //           "voice": ""
    //         }
    //       )
    //       console.log(tigan1)
    //     }
    //     that.tigan.push(tigan1)
    //     console.log(that.tigan)
    //     let xuanA={
    //       "sn": 1,
    //       "intro": A[0],
    //       "image": "",
    //       "voice": ""
    //     }
    //     let xuanB={
    //       "sn": 2,
    //       "intro": B[0],
    //       "image": "",
    //       "voice": ""
    //     }
    //     let xuanC={
    //       "sn": 3,
    //       "intro": C[0],
    //       "image": "",
    //       "voice": ""
    //     }
    //     let daan=''
    //     if(DaAn[0] == 'A '){
    //       daan=[xuanA]

    //     }else if(DaAn[0] == 'B '){
    //       daan=[xuanB]

    //     }else if(DaAn[0] == 'C '){
    //       daan=[xuanC]

    //     }
    //     that.answerSelection.push(daan)

    //     let questionData1 = []
    //     that.xuanxiang=[xuanA,xuanB,xuanC]
    //     questionData1=[tigan1,that.xuanxiang]

    //     that.questionData.push(questionData1)
    //   }
    //   console.log(that.questionData)
    //   console.log(that.answerSelection)
    //   console.log(that.questionTypesAV)
    //   for(let k in that.questionData){
    //     const todo = new NJQuestion();
    //     todo.set('questionData',that.questionData[k])
    //     todo.set('answerSelection',that.answerSelection[k])
    //     todo.set('license','wxc534f9ed8a9993da')
    //     todo.set('grade',that.grade[33])
    //     todo.set('answerType',0)
    //     todo.set('questionType',that.questionTypesAV[0])
    //     todo.save().then( res=>{
    //       console.log(res)
    //     }).catch(err=>{
    //       console.log(err)
    //     })
    //   }
    // }
  }
};
</script>
<style scoped>
</style>